import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { OwnerOutreachPage } from '../shared/OwnerOutreachPage';

const AdminOwnerOutreachPage: React.FC = () => {
  return (
    <AdminLayout>
      <OwnerOutreachPage mode="admin" />
    </AdminLayout>
  );
};

export default AdminOwnerOutreachPage;
